<cs-header>
  <cs-header-title>{{ LL.coach.tier.becomeCoach() }}</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    @if (loading) {
      <!-- server gate in flight, before the embedded checkout can open -->
      <cs-card>
        <cs-card-content>
          <div class="gate-loading">
            <cs-spinner></cs-spinner>
          </div>
        </cs-card-content>
      </cs-card>
    } @else {
      <!-- per-seat billing explainer. The Paddle frame below shows the price but
           NOT that each client adds a seat, so spell out the pay-per-seat model
           clearly here BEFORE the coach pays (owner requirement). -->
      <cs-card class="billing-explainer">
        <cs-card-title>{{ LL.coach.checkout.billingTitle() }}</cs-card-title>
        <cs-card-content>
          <cs-note light>{{ LL.coach.checkout.billingInfo() }}</cs-note>
        </cs-card-content>
      </cs-card>

      <!-- Embedded Paddle checkout card (parity with the subscribe page). The
           inline frame mounts into `.paddle-checkout-frame` (see the page's
           frameTarget); the frame-ready poll waits for this container to render. -->
      <cs-card class="payment-card">
        @if (loadingCheckout) {
          <!-- the id is a stable hook for the become-a-coach E2E: this overlay is
               raised synchronously by onContinueAsync() before its first await, so
               its presence is the proof that the Continue tap reached the handler.
               Keyed on an id rather than the styling classes so a future SCSS
               rename cannot silently break that check. -->
          <div id="coach-checkout-finalizing" class="spinner overlay">
            <cs-spinner></cs-spinner>
          </div>
        }
        <!-- no title here: the Paddle inline frame has its own heading, so a
             title would be redundant and overlap the frame. -->
        <div class="paddle-checkout-frame checkout-frame"></div>
        <!-- once payment succeeds Paddle shows its success screen in the frame
             above; surface our own Continue button so the coach reads that
             success and taps to proceed. Continue polls for the coach-seat grant
             and reloads (see onContinueAsync) — we never force-reload out from
             under the success screen. -->
        @if (purchaseComplete) {
          <div class="payment-footer">
            <cs-button medium primary fit-width id="coach-checkout-continue-paddle"
              [label]="LL.subscribe.messages.continueAfterPurchase()"
              (click)="onContinueAsync()"></cs-button>
          </div>
        }
      </cs-card>
    }
  </cs-card-list>
</cs-content>
